// extracted by mini-css-extract-plugin
export default {"host":"style_host__ZZTeq","table":"style_table__1T4VM","headerRow":"style_headerRow__9+n2h","borderLeft":"style_borderLeft__X12y4","borderRight":"style_borderRight__8Qr+w"};